import { Model } from '@vuex-orm/core';
import { ScopeProfile } from './match/ScopeProfile';

/**
 * ORM Model
 * @see {@link https://vuex-orm.github.io/vuex-orm/guide/components/models.html}
 */
export class User extends Model {
  static entity = 'users'

  static primaryKey = 'id'

  static fields () {
    return {
      id: this.attr(null),
      profile: this.hasMany(ScopeProfile, 'user_id')
    };
  }
}
